
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/about-us",
      function () {
        return require("private-next-pages/franchise/about-us.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/about-us"])
      });
    }
  